module.exports = __webpack_public_path__ + "static/img/erweima2.b1287a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/erweima2.png
// module id = wgbt
// module chunks = 3